import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations } from './translations';

const LangContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: (key) => key,
});

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState('en');

  useEffect(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('a7_lang') : null;
    if (saved === 'en' || saved === 'es') setLangState(saved);
  }, []);

  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem('a7_lang', next); } catch (_) {}
    document.documentElement.lang = next;
  }, []);

  const t = useCallback((key) => {
    const parts = key.split('.');
    let node = translations[lang];
    for (const p of parts) {
      if (node && typeof node === 'object' && p in node) node = node[p];
      else return key;
    }
    return node;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
